import { catalogRecordSystemKeys } from "src/common/systemKey";

import { ZClassificationInternal } from "./ZClassificationInternal";

export const extractClassIdsFromFieldsValue = (
  fieldsValue: Record<string, unknown>,
): string[] => {
  const classification = fieldsValue[catalogRecordSystemKeys.classification] as
    | ZClassificationInternal
    | undefined;
  if (!classification) return [];
  return Object.values(classification)
    .flatMap((classes) => classes?.map(({ id }) => id))
    .filter(Boolean) as string[];
};
